// extracted by mini-css-extract-plugin
export default {"title":"ISError_title__x6efQ","text":"ISError_text__F3VeT","image":"ISError_image__BM7kT","anim":"ISError_anim__HMBil"};